import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox, Stack } from '@ardoq/layout';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { Notifier } from '@ardoq/dropdown-menu';
import { t, Trans, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoDataWithZeroDegreesDoqProps = {
  doqType: DoqType;
  includeActions?: boolean;
  changeSettingAction?: Notifier;
  i18nLocale: I18nLocale;
};

const NoDataWithZeroDegreesDoqBase = ({
  doqType,
  includeActions = true,
  changeSettingAction,
  i18nLocale,
}: NoDataWithZeroDegreesDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noDataWithZeroDegrees.title',
          'There is nothing to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDataWithZeroDegrees.message1',
                'No components to display when the degree of relationship is set to zero.'
              )}
            </FlexBox>
            <FlexBox gap="medium">
              <span style={{ display: 'inline' }}>
                <Trans
                  i18nKey="tabview:graphViews.emptyState.noDataWithZeroDegrees.message2"
                  defaults='To show more data, change the view modifier "<icon/>"'
                  components={{
                    icon: (
                      <Icon
                        iconSize={IconSize.SMALL}
                        iconName={IconName.ACCOUNT_TREE}
                      />
                    ),
                  }}
                />
              </span>
            </FlexBox>
          </Stack>
        }
        buttonLabel={
          includeActions
            ? t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDataWithZeroDegrees.changeSetting',
                'Change setting'
              )
            : undefined
        }
        onButtonClick={
          includeActions && changeSettingAction
            ? () => changeSettingAction.notify()
            : undefined
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoDataWithZeroDegreesDoq = connect(
  NoDataWithZeroDegreesDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
